// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__2Wev8","alertIcon":"ConfirmModal_alertIcon__3r5mk"};